import { createContext, ReactNode, useEffect, useState } from 'react';
import { fetchRemoteI18n, RemoteI18nData } from './service';

export const RemoteI18nContext = createContext<RemoteI18nData | null>(null);

export const RemoteI18nDataProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [remoteI18nData, setRemoteI18nData] = useState<RemoteI18nData | null>(
    null,
  );
  useEffect(() => {
    const setRemoteI18n = async () => {
      const data = await fetchRemoteI18n();
      setRemoteI18nData(data);
    };
    setRemoteI18n();
  }, []);
  return (
    <RemoteI18nContext.Provider value={remoteI18nData}>
      {children}
    </RemoteI18nContext.Provider>
  );
};
